import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxSpinnerModule } from "ngx-spinner";
import { CKEditorModule } from 'ng2-ckeditor';
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { ToastrModule } from 'ngx-toastr';
import { MatPaginatorModule, MatRadioModule, MatSlideToggleModule, MatTableModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    CKEditorModule,
    MatTableModule,
    MatRadioModule,
    MatPaginatorModule,
    ToastrModule.forRoot({
      tapToDismiss: true,
      positionClass: 'toast-top-right',
      timeOut: 5000,
      preventDuplicates: true,
      closeButton: true
    }),


  ],
  declarations: [],
  exports: [FormsModule, ReactiveFormsModule, NgxDatatableModule, NgxSpinnerModule, CKEditorModule,MatTableModule,MatPaginatorModule,MatRadioModule,MatSlideToggleModule
  ],
  providers: []
})
export class SharedModule { }
